module.exports = __webpack_public_path__ + "static/media/request-history-empty.378659f9.svg";